<div class="component-viewer">
    <h1>Edit Prize</h1>
    <mat-card *ngIf="canEditPrize && selectedIteration">
        <mat-card-content>
            <div class="container-fluid">
                <div class="row">
                    <mat-progress-bar mode="indeterminate" *ngIf="isLoading"></mat-progress-bar><br />
                </div>
            </div>
            <form [formGroup]="form" (ngSubmit)="onSubmit(form)">
                <div class="continer-fluid">
                    <div class="row">
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Name</mat-label>
                                <input matInput required name="name" id="name" placeholder="Name" type="text"
                                    formControlName="name" />
                                <mat-error *ngIf="form.get('name').errors?.required">Name is required
                                </mat-error>
                                <mat-error *ngIf="form.get('name').errors?.validationErrors">
                                    {{ form.get("name").errors?.validationErrors}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Description</mat-label>
                                <input required matInput name="description" id="description" placeholder="Description"
                                    type="text" formControlName="description" />
                                <mat-error *ngIf="form.get('description').errors?.required">Description is required
                                </mat-error>
                                <mat-error *ngIf="form.get('description').errors?.validationErrors">
                                    {{ form.get("description").errors?.validationErrors}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Value</mat-label>
                                <input required matInput name="value" id="value" placeholder="Value" type="number"
                                    formControlName="value" />
                                <mat-icon matPrefix style="vertical-align: middle;">attach_money</mat-icon>
                                <mat-error *ngIf="form.get('value').errors?.required">Value is required
                                </mat-error>
                                <mat-error *ngIf="form.get('value').errors?.validationErrors">
                                    {{ form.get("value").errors?.validationErrors}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col">
                            <mat-form-field>
                                <mat-label>Expense Cost</mat-label>
                                <input required matInput name="expenseCost" id="expenseCost" placeholder="Expense Cost"
                                    type="number" formControlName="expenseCost" />
                                <mat-icon matPrefix style="vertical-align: middle;">attach_money</mat-icon>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-1">
                            <button mat-raised-button>Save</button>
                        </div>
                        <div class="col-1">
                            <button mat-raised-button color="warn"
                                [routerLink]="['/outing-management','administration','prizes']">Cancel</button>
                        </div>
                    </div>
                </div>
            </form>
        </mat-card-content>
    </mat-card>
    <mat-card *ngIf="!canEditPrize">
        <mat-card-content>
            <div class="mat-h3">Sorry, unable to edit this prize for the selected outing and date. Please select a
                different outing or date</div>
        </mat-card-content>
    </mat-card>
</div>